export default "__VITE_ASSET__DxO402lf__"